import React, { useRef, useEffect, useContext, useState } from 'react'
import { Grid, Selector, Slider, Switch } from 'antd-mobile'
import { } from 'antd'
import CustomSlider from './CustomSlider'
import { AvatarContext } from '@/components/RenderComp/Avatar'

const FacePupComp = (props) => {
    const {
        facepup,
        selectedTypeInCurrentPart,
        meshPoints,
        bodyPitchs,
        setMeshPoints,
        setBodyPitchs
    } = props
    const { avatar } = useContext(AvatarContext)
    const [facepupMode, setFacepupMode] = useState(
        facepup.fundamental.length > 0 ? 'fundamental' : 'advanced'
    )
    const handleValueInput = (item, value, map) => {
        if (!avatar) return
        const target = value > 0 ? item.pos : item.neg
        for (let opField of target) {
            avatar.setBoneTransform(opField, Math.abs(value) / 50)
        }
        if (map === 'meshPoints') {
            const key = item.pos[0].slice(0, -3)
            const draft = { ...meshPoints }
            draft[key] = value
            console.log('meshPoints', draft)
            setMeshPoints(draft)
        } else {
            const key = item.pos[0].slice(0, item.pos[0].lastIndexOf('_'))
            const draft = { ...bodyPitchs }
            draft[key] = value
            setBodyPitchs(draft)
        }
    }
    console.log(facepup)
    return (
        <div
            className='facepup-wrap'
            key={facepup.key}
        >
            {
                facepup.fundamental && facepup.advanced && facepup.fundamental.length > 0 && facepup.advanced.length > 0 && (
                    <div className="facepup-mode-switch">
                        <div
                            className={
                                facepupMode === 'fundamental'
                                    ? "facepup-mode-switch-item active"
                                    : "facepup-mode-switch-item"
                            }
                            onClick={() => setFacepupMode('fundamental')}
                        >
                            简易
                        </div>
                        <div
                            className={
                                facepupMode === 'advanced'
                                    ? "facepup-mode-switch-item active"
                                    : "facepup-mode-switch-item"
                            }
                            onClick={() => setFacepupMode('advanced')}
                        >
                            专家
                        </div>
                    </div>
                )
            }
            <div style={{ padding: '0 16px' }}>
                {
                    (
                        facepupMode === 'fundamental'
                            ? facepup[facepupMode].map((item) => {
                                if (!selectedTypeInCurrentPart || item.disabled) return null
                                return selectedTypeInCurrentPart.type !== 'conf' ? (
                                    <CustomSlider
                                        title={item.displayName}
                                        value={
                                            meshPoints[
                                            item.pos[0].slice(0, -3)
                                            ]
                                        }
                                        onChange={(value) =>
                                            handleValueInput(
                                                item,
                                                value,
                                                'meshPoints'
                                            )
                                        }
                                    />
                                ) : (
                                    <CustomSlider
                                        title={item.displayName}
                                        value={
                                            bodyPitchs[
                                            item.pos[0].slice(0, item.pos[0].lastIndexOf('_'))
                                            ]
                                        }
                                        onChange={(value) =>
                                            handleValueInput(
                                                item,
                                                value,
                                                'bodyPitchs'
                                            )
                                        }
                                    />
                                )
                            })
                            : facepup[facepupMode].map(facepupTypeObj => {
                                return <div style={{ margin: '12px 0' }}>
                                    <p style={{ color: '#131155', fontWeight: 500 }}>
                                        {facepupTypeObj.displayName}
                                    </p>
                                    <div>
                                        {facepupTypeObj.ops.map(item => {
                                            if (!selectedTypeInCurrentPart || item.disabled) return null
                                            return selectedTypeInCurrentPart.type !== 'conf' ? (
                                                <CustomSlider
                                                    title={item.displayName}
                                                    value={
                                                        meshPoints[
                                                        item.pos[0].slice(0, -3)
                                                        ]
                                                    }
                                                    onChange={(value) =>
                                                        handleValueInput(
                                                            item,
                                                            value,
                                                            'meshPoints'
                                                        )
                                                    }
                                                />
                                            ) : (
                                                <CustomSlider
                                                    title={item.displayName}
                                                    value={
                                                        bodyPitchs[
                                                        item.pos[0].slice(0, item.pos[0].lastIndexOf('_'))
                                                        ]
                                                    }
                                                    onChange={(value) =>
                                                        handleValueInput(
                                                            item,
                                                            value,
                                                            'bodyPitchs'
                                                        )
                                                    }
                                                />
                                            )
                                        })}
                                    </div>
                                </div>
                            })
                    )
                }
            </div>
        </div>
    )
}

export default FacePupComp
